module.exports = __webpack_public_path__ + "static/potm-logo-6fbfcffd717a73d24b15a684816d9042.svg";